import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

import navigationLocalization from '../../localization/navigation'

import styles from './Footer.module.styl'

const Footer = (props) => {
  const { language } = props

  const renderNavItems = () => {
    return Object.keys(navigationLocalization).map(page => (
      <Link
        key={navigationLocalization[page][language]}
        to={`/${navigationLocalization[page][language].toLowerCase().replace(' ', '')}`}
        className={styles.menuItem}
        activeClassName={styles.menuItemActive}
      >
        {navigationLocalization[page][language]}
      </Link>
    ))
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.copyright}>
        &copy; {new Date().getFullYear()} Ferienhaus Vulkaneifel Kopp
      </div>

      <div className={styles.menu}>
        <Link
          to="/"
          exact
          className={styles.menuItem}
          activeClassName={styles.menuItemActive}
        >
          Home
        </Link>
        {renderNavItems()}
      </div>
    </footer>
  )
}

Footer.propTypes = {
  language: PropTypes.string.isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js